import { createActionConst } from '../../../utils/action.utils';

const MEETING_FOLDER_NAMESPACE = 'MEETING_FOLDER';

export const STORE_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'STORE_MEETING_FOLDER');
export const CLEAR_MEETING_FOLDER = createActionConst(MEETING_FOLDER_NAMESPACE, 'CLEAR_MEETING_FOLDER');
